import { AlertCircle } from "lucide-react"
import { Button } from "@/components/ui/button"

interface AuthErrorScreenProps {
  error: Error
  onRetry: () => void
}

export function AuthErrorScreen({ error, onRetry }: Readonly<AuthErrorScreenProps>) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <div className="rounded-full bg-destructive/10 p-3">
        <AlertCircle className="size-6 text-destructive" />
      </div>
      <h2 className="text-lg font-medium">Authentication Error</h2>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {error.message || "An error occurred during authentication."}
      </p>
      <Button onClick={onRetry}>Try Again</Button>
    </div>
  )
}
